module.exports = __webpack_public_path__ + "img/logo-big.7fa0bd4b.png";